

import { Component, Vue, Prop } from "vue-property-decorator"

import { calculatedValueDisplay } from "@/mixins/calculatedValueDisplay"

import vSelect from "vue-select"
import FieldPermissions from "@/components/Config/Permissions/FieldPermissions.vue"
import ColumnFormatting from "@/components/Controls/ColumnFormatting.vue"
import DataSourceSelect from "./DataSourceSelect.vue"
import DataSourceTemplate from "./DataSourceTemplate.vue"
import Numeric from "./Numeric.vue"
import DateTime from "./DateTime.vue"
import MapLocation from "./MapLocation.vue"
import ExternalLink from "./ExternalLink.vue"
import TextAreaToggleExpand from "./TextAreaToggleExpand.vue"
import { operatorsByFieldType } from "@/types/insights/operators"
import { CaseColumn } from "@/types/caseColumns"
import { dataTypeByFieldType } from "@/types/dataType"
import { maxInputLength } from "@/constants/input"
import DayOfWeekSetting from "../Config/TenantSettings/DayOfWeekSetting.vue"
import IconUpload from "@/components/IconUpload.vue"

@Component({
	components: {
		"v-select": vSelect,
		"numeric": Numeric,
		"field-permissions": FieldPermissions,
		"data-select": DataSourceSelect,
		"data-template": DataSourceTemplate,
		"date-time": DateTime,
		"map-location": MapLocation,
		"external-link": ExternalLink,
		"text-area-expand": TextAreaToggleExpand,
		"column-formatting": ColumnFormatting,
		"day-of-week-setting": DayOfWeekSetting,
		"icon-upload": IconUpload
	}
})
export default class FieldControl extends Vue {
	@Prop()
	fieldKey: any

	@Prop()
	item: any

	@Prop()
	field: any

	@Prop()
	value: any

	@Prop({ type: Boolean, default: true })
	state!: boolean

	@Prop({ type: Boolean, default: false })
	readonly!: boolean

	private get selectOptions () {
		if (typeof (this.field.options) === "function") {
			return this.field.options(this.item)
		}
		return this.field.options
	}

	private changeColumnCheck () {
		this.$emit("input", !this.value)
	}

	/** Get the label for select options */
	private get selectLabel () {
		if (this.field.selectLabel) { // TODO: Add a check to see if the label matches what's on the select options.
			return this.field.selectLabel as String
		} else return "title"
	}

	public get calculatedFieldDisplayValue () {
		return calculatedValueDisplay.methods.displayCalculatedField(this.item, this.field.extensions, this.value)
	}

	private formatLength (input: string): string {
		return String(input).substring(0, maxInputLength)
	}

	private get getCaseColumn () {
		if (this.item.dataType) {
			var column : CaseColumn = {
				key: "DataType",
				label: "DataType",
				dataType: this.item.dataType,
				fieldDataType: dataTypeByFieldType[this.item.dataType],
				dynamicField: false,
				operators: operatorsByFieldType[this.item.dataType] // lookup datatype, get operators.
			}
			return column
		}
	}
}

